import i18next from 'i18next';

i18next.addResources('es', 'CaseField', {
  search: 'Buscar...',
  datePlaceholder: '--/--/----'
});
